@for (x of rowsArray; track x) {
  <tr>
    @for (y of colsArray; track y) {
      <td>
        <app-placeholder />
      </td>
    }
  </tr>
}
